// Catálogos del subtab Documentación (Listado de documentación y Listado de correspondencia).
// Igual que el catálogo de aeropuertos (airports.js), las etiquetas son datos canónicos del cliente:
// el identificador estable es el código y ese código es el que entra en el "código completo".

// Disciplinas (código + nombre). Alimentan el emisor/receptor de correspondencia interna y la
// disciplina del listado de documentación.
export const DOC_DISCIPLINES = [
  { code: 'DPR', name: 'GENERAL (PROYECTOS & OPERACIONES)' },
  { code: 'PLN', name: 'PLANIFICACIÓN & CONTROL' },
  { code: 'PMO', name: 'PROJECT MANAGEMENT OFFICE' },
  { code: 'FLD', name: 'FIELD (OPERACIONES)' },
  { code: 'DOC', name: 'GESTIÓN DOCUMENTAL' },
  { code: 'CON', name: 'GESTIÓN CONTRACTUAL' },
  { code: 'ADM', name: 'GESTIÓN ADMINISTRATIVA' },
  { code: 'SER', name: 'SERVICES' },
  { code: 'Q&S', name: 'QUALITY & SUSTAINABILITY' },
  { code: 'CAR', name: 'CONTROLLING ACCOUNTING & RISK' },
  { code: 'ENG', name: 'ENGINEERING' },
]

// Tipos de documento (nombre + código de 2 letras que forma parte del código completo).
export const DOC_TYPES_CODED = [
  { code: 'AC', name: 'ACTAS DE REUNIÓN' },
  { code: 'AE', name: 'AUTORIZACIÓN DE ENVÍO' },
  { code: 'CR', name: 'CERTIFICADOS' },
  { code: 'DC', name: 'SOLICITUD DE ACLARACIÓN' },
  { code: 'DO', name: 'DOSIERES' },
  { code: 'DS', name: 'BASES DE DISEÑO' },
  { code: 'ET', name: 'ESPECIFICACIÓN TÉCNICA' },
  { code: 'EV', name: 'EVALUACIÓN TÉCNICA' },
  { code: 'HT', name: 'HOJA DE TRANSMITTAL' },
  { code: 'IN', name: 'INFORME / REPORTE' },
  { code: 'LR', name: 'CARTA' },
  { code: 'LT', name: 'LISTA' },
  { code: 'ME', name: 'DESCRIPCIÓN' },
  { code: 'MN', name: 'MANUAL' },
  { code: 'NC', name: 'NO CONFORMIDAD' },
  { code: 'NT', name: 'NOTA TÉCNICA' },
  { code: 'OC', name: 'ORDEN DE CAMBIO' },
  { code: 'PA', name: 'PLANIFICACIÓN' },
  { code: 'PL', name: 'PLANES' },
  { code: 'PO', name: 'PROCEDIMIENTOS' },
  { code: 'PR', name: 'PROTOCOLOS' },
  { code: 'RC', name: 'RECLAMACIÓN' },
  { code: 'SC', name: 'SOLICITUD DE CAMBIO' },
  { code: 'ST', name: 'ESTÁNDAR' },
  { code: 'VV', name: 'VARIOS' },
]

// Tipos de emisor externo: el prefijo forma el código correlativo (S001, C001...). La etiqueta
// se traduce en el componente (labelKey) porque es texto de interfaz, no un dato del catálogo.
export const ISSUER_EXTERNAL_TYPES = [
  { value: 'supplier', prefix: 'S', labelKey: 'prm_summary_s04_issuer_supplier' },
  { value: 'subcontractor', prefix: 'C', labelKey: 'prm_summary_s04_issuer_subcontractor' },
]

// Opciones para los selectores (valor = código; etiqueta como en el diseño).
export function disciplineOptions () {
  return DOC_DISCIPLINES.map((d) => ({ value: d.code, label: d.code + ' · ' + d.name }))
}
export function docTypeOptions () {
  return DOC_TYPES_CODED.map((t) => ({ value: t.code, label: t.name + ' · ' + t.code }))
}

// Búsquedas de nombre por código (para pintar la tabla).
export function disciplineName (code) {
  const d = DOC_DISCIPLINES.find((x) => x.code === code)
  return d ? d.name : (code || '')
}
export function docTypeName (code) {
  const t = DOC_TYPES_CODED.find((x) => x.code === code)
  return t ? t.name : (code || '')
}

// Siguiente código correlativo de un emisor externo según su prefijo (S001, S002, C001...).
export function nextIssuerCode (issuers, prefix) {
  let max = 0
  for (const e of issuers || []) {
    if (e.code && e.code.charAt(0) === prefix) {
      const n = parseInt(e.code.slice(1), 10) || 0
      if (n > max) max = n
    }
  }
  return prefix + String(max + 1).padStart(3, '0')
}
